import { c as _c } from "react/compiler-runtime";
import { Hint } from '@systemeio/ui';
import { onChangeRuleStatus, onDeleteRule } from 'modules/automation-rules/api/automation-rules-api';
import { SpecificTriggerRulesProps } from 'modules/automation-rules/specific-trigger-rules';
import { triggerActionLocoKeys, triggerDescriptionLocoKeys } from 'modules/automation-rules/triggers/constants/trigger-loco-keys';
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { getTriggerIcon } from 'modules/automation-rules/triggers/utils/get-trigger-icon';
import { AutomationRuleApiInterface, AutomationRuleInterface } from 'modules/automation-rules/types/automation-rule-interface';
import ConfirmationModal from 'shared/components/confirmation-modal';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { StatusCell } from 'shared/components/table/cells/status-cell';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { KeyedMutator } from 'swr';
import { twMerge } from 'tailwind-merge';
interface SpecificTriggerRulesTableProps extends Pick<SpecificTriggerRulesProps, 'getRelatedAndUnrelatedTriggersData' | 'noRelatedMessage'> {
  rules?: AutomationRuleApiInterface;
  mutateRules: KeyedMutator<AutomationRuleApiInterface>;
  setSelectedRuleId: (ruleId: number) => void;
  mutateAvailableTriggers: KeyedMutator<AutomationRuleTriggersEnum[]>;
}
const SpecificTriggerRulesTable = t0 => {
  const $ = _c(56);
  const {
    rules,
    mutateRules,
    setSelectedRuleId,
    mutateAvailableTriggers,
    getRelatedAndUnrelatedTriggersData,
    noRelatedMessage
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== mutateRules) {
    t1 = async rule => {
      await onChangeRuleStatus(rule.active, rule.id);
      await mutateRules(data => data && {
        ...data,
        items: data.items.map(el => {
          if (el.id === rule.id) {
            return {
              ...el,
              active: !el.active
            };
          }
          return el;
        })
      }, false);
    };
    $[0] = mutateRules;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const changeRuleStatus = t1;
  let t2;
  if ($[2] !== mutateAvailableTriggers || $[3] !== mutateRules) {
    t2 = async rule_0 => {
      await onDeleteRule(rule_0.id);
      await mutateRules(data_0 => data_0 && {
        ...data_0,
        items: data_0.items.filter(el_0 => el_0.id !== rule_0.id)
      }, false);
      await mutateAvailableTriggers();
    };
    $[2] = mutateAvailableTriggers;
    $[3] = mutateRules;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const deleteRule = t2;
  let t3;
  if ($[5] !== getRelatedAndUnrelatedTriggersData || $[6] !== noRelatedMessage || $[7] !== t) {
    t3 = {
      key: "triggers",
      header: "",
      widthPercent: 95,
      onRender: rule_1 => {
        const {
          relatedTriggers,
          unrelatedTriggers
        } = getRelatedAndUnrelatedTriggersData(rule_1.triggers);
        return <Hint showHint={unrelatedTriggers.length !== 0} label={noRelatedMessage(rule_1.id)}><div className="flex w-full flex-col">{relatedTriggers.map((el_1, idx) => <div key={el_1.type + idx} className={twMerge("flex flex-col gap-1 py-3", idx !== 0 ? "border-text-secondary/30 border-t" : "pt-0", idx + 1 === relatedTriggers.length && "pb-0")}><div className="flex items-center gap-3">{getTriggerIcon(el_1.type)}<div className="flex flex-col gap-1 overflow-hidden"><span className="text-text-primary truncate text-[15px] font-bold">{t(triggerActionLocoKeys[el_1.type])}</span><span className="truncate">{t(triggerDescriptionLocoKeys[el_1.type])}</span></div></div></div>)}</div></Hint>;
      }
    };
    $[5] = getRelatedAndUnrelatedTriggersData;
    $[6] = noRelatedMessage;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      key: "active",
      header: "",
      widthPercent: 5,
      onRender: _temp
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3) {
    t5 = [t3, t4];
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const columns = t5;
  let t6;
  if ($[12] !== setSelectedRuleId) {
    t6 = instance => setSelectedRuleId(instance.id);
    $[12] = setSelectedRuleId;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("dashboard.automation_rule.edit.title");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== setSelectedRuleId) {
    t8 = rule_3 => setSelectedRuleId(rule_3.id);
    $[16] = setSelectedRuleId;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = {
      name: "edit-rule",
      caption: t7,
      onActionClick: t8
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("dashboard.automation_rule.edit.enable");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== changeRuleStatus || $[24] !== t) {
    t11 = (opened, onClose, instance_0, key) => <ConfirmationModal key={key} confirmationText={t("dashboard.automation_rule.edit.enable_confirm")} toastCaption={t("dashboard.automation_rule.edit.enable_success")} opened={opened} onClose={onClose} onConfirm={() => changeRuleStatus(instance_0)} />;
    $[23] = changeRuleStatus;
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = {
      name: "enable-rule",
      caption: t10,
      shouldRender: _temp2,
      onActionRender: t11
    };
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("dashboard.automation_rule.edit.disable");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== changeRuleStatus || $[32] !== t) {
    t14 = (opened_0, onClose_0, instance_1, key_0) => <ConfirmationModal key={key_0} confirmationText={t("dashboard.automation_rule.edit.disable_confirm")} toastCaption={t("dashboard.automation_rule.edit.disable_success")} opened={opened_0} onClose={onClose_0} onConfirm={() => changeRuleStatus(instance_1)} />;
    $[31] = changeRuleStatus;
    $[32] = t;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t13 || $[35] !== t14) {
    t15 = {
      name: "disable-rule",
      caption: t13,
      shouldRender: _temp3,
      onActionRender: t14
    };
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t) {
    t16 = t("dashboard.automation_rule.edit.delete");
    $[37] = t;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== deleteRule || $[40] !== getRelatedAndUnrelatedTriggersData || $[41] !== t) {
    t17 = (opened_1, onClose_1, instance_2, key_1) => {
      const {
        unrelatedTriggers: unrelatedTriggers_0
      } = getRelatedAndUnrelatedTriggersData(instance_2.triggers);
      const hasUnrelatedTriggers = unrelatedTriggers_0.length !== 0;
      return <ConfirmationModal key={key_1} toastCaption={t("dashboard.automation_rule.edit.delete_success")} confirmationText={hasUnrelatedTriggers ? <TransLoco t={t} i18nKey="dashboard.funnel.automation_rules.delete_rule.confirmation" components={{
        b: <b />
      }} /> : t("dashboard.automation_rule.edit.delete_confirm")} opened={opened_1} onClose={onClose_1} onConfirm={() => deleteRule(instance_2)} />;
    };
    $[39] = deleteRule;
    $[40] = getRelatedAndUnrelatedTriggersData;
    $[41] = t;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t16 || $[44] !== t17) {
    t18 = {
      name: "delete-rule",
      caption: t16,
      onActionRender: t17
    };
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t12 || $[47] !== t15 || $[48] !== t18 || $[49] !== t9) {
    t19 = {
      custom: [t9, t12, t15, t18]
    };
    $[46] = t12;
    $[47] = t15;
    $[48] = t18;
    $[49] = t9;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== columns || $[52] !== rules || $[53] !== t19 || $[54] !== t6) {
    t20 = <Table onRowClick={t6} noHeader={true} actions={t19} data={rules} columns={columns} />;
    $[51] = columns;
    $[52] = rules;
    $[53] = t19;
    $[54] = t6;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  return t20;
};
export default SpecificTriggerRulesTable;
function _temp(rule_2) {
  return <StatusCell isActive={rule_2.active} />;
}
function _temp2(rule_4) {
  return !rule_4.active;
}
function _temp3(rule_5) {
  return rule_5.active;
}